import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'notify-user-existing-auth',
  templateUrl: './notify-user-existing-auth.component.html',
  styleUrls: ['./notify-user-existing-auth.component.css']
})
export class NotifyUserExistingAuthComponent implements OnInit {

  constructor(
    protected dialogRef: NbDialogRef<NotifyUserExistingAuthComponent>,
  private translate: TranslateService) { }

  ngOnInit(): void {
  }

  registerAuthorization(){
    this.dialogRef.close('register');
  }

  viewAuthorization(){
    this.dialogRef.close('view');
  }

}
